import * as React from 'react';

import { createIcon } from '../Icon';
export const RotateCcwIcon = createIcon(
  <React.Fragment>
    <polyline points="1 4 1 10 7 10" />
    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
  </React.Fragment>,
  'RotateCcwIcon'
);
